/* ================================================================
   Magnetic Track Landing Page — Form + Clarity event wiring
   ================================================================
   - Hooks the bottom lead-form to redirect to WhatsApp with form
     data pre-filled (same pattern as configurator).
   - Fires Microsoft Clarity Smart Events on every CTA / scroll
     milestone defined in the SKILL's clarity-playbook.md.
   - Vanilla JS, no dependencies.
   ================================================================ */
(function () {
  'use strict';

  function fireClarity(name, data) {
    try {
      if (window.clarity) {
        window.clarity('event', name);
        if (data) {
          Object.keys(data).forEach(function (k) {
            window.clarity('set', k, String(data[k]));
          });
        }
      }
    } catch (e) { /* Clarity not loaded */ }
  }

  // ============ CTA / event wiring ============
  document.querySelectorAll('[data-mt-event]').forEach(function (el) {
    el.addEventListener('click', function () {
      var ev = el.getAttribute('data-mt-event');
      if (ev) fireClarity(ev);
      // Track variant clicks with custom tag
      if (ev === 'variant_card_click') {
        var v = el.getAttribute('data-mt-variant');
        if (v) fireClarity('variant_card_click', { track_type: v });
      }
    });
  });

  // ============ Bottom lead form → WhatsApp redirect ============
  var leadform = document.getElementById('mt-leadform');
  if (leadform) {
    leadform.addEventListener('submit', function (e) {
      e.preventDefault();
      var fd = new FormData(leadform);
      var name = (fd.get('name') || '').toString().trim();
      var phone = (fd.get('phone') || '').toString().trim();
      var pincode = (fd.get('pincode') || '').toString().trim();
      var projectType = (fd.get('project_type') || '').toString().trim();

      if (!name || !phone || !projectType) {
        leadform.reportValidity();
        return;
      }

      // Build message
      var msg = [
        "Hi Jainsons! I'd like more information about magnetic track lighting.",
        "",
        "Name: " + name,
        "WhatsApp: " + phone,
        pincode ? ("Pincode: " + pincode) : "",
        "Project type: " + projectType,
        "",
        "Please share catalogue and pricing."
      ].filter(function (l) { return l !== ""; }).join("\n");

      // Get WhatsApp base URL (try same as configurator pattern; fallback to default)
      var whatsappBase = leadform.getAttribute('action') || 'https://wa.me/919899188821';
      // Strip any existing query so we send a clean text param
      var clean = whatsappBase.split('?')[0];
      var url = clean + '?text=' + encodeURIComponent(msg);

      fireClarity('form_submit', {
        user_type: projectType,
        intent: 'quote'
      });

      window.open(url, '_blank');
    });
  }

  // ============ Scroll-based events ============
  // Fire pricing_section_view, system_diagram_view, hero_visible
  // when their respective elements scroll into view.
  if ('IntersectionObserver' in window) {
    var pageEvents = {
      '.mt-hero': 'hero_visible',
      '.mt-system-explainer': 'system_diagram_view',
      '.mt-variants': 'variant_section_view',
      '.mt-leadcapture': 'leadcapture_section_view'
    };

    var observed = {};
    Object.keys(pageEvents).forEach(function (sel) {
      var el = document.querySelector(sel);
      if (!el) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.intersectionRatio >= 0.5 && !observed[sel]) {
            observed[sel] = true;
            fireClarity(pageEvents[sel]);
            io.disconnect();
          }
        });
      }, { threshold: [0.5] });
      io.observe(el);
    });
  }

  // ============ Set traffic_source custom tag on landing ============
  try {
    if (window.clarity) {
      var params = new URLSearchParams(window.location.search);
      var source = params.get('utm_source') || document.referrer || 'direct';
      window.clarity('set', 'traffic_source', source);
    }
  } catch (e) { /* noop */ }
})();
